import { computed, unref } from 'vue'
import {
  BID_VALUE_TYPE,
  EXTERNAL_ACTION_LIST,
  DEEP_EXTERNAL_ACTION_LIST,
  DEEP_BID_TYPE,
  DEEP_BID_TYPE_LIST,
  DELIVERY_MODE,
  BUDGET_OPTIMIZE_SWITCH,
  BID_TYPE,
  AD_TYPE,
  DELIVERY_TYPE,
  BLUE_FLOW_PACKAGE_SETTING_SWITCH
} from '../consts/index.js'

/**
 * @description: 优化目标相关性
 * @param {*} configForm
 * @return {*}
 */
export const useOptimizeGoalRelative = (projectForm) => {
  // 是否通投广告
  const isAll = computed(() => unref(projectForm).ad_type === AD_TYPE.ALL)
  // 是否自动投放
  const isProcedural = computed(() => unref(projectForm).delivery_mode === DELIVERY_MODE.PROCEDURAL && isAll.value)

  // 是否搜索广告
  const isSearch = computed(() => unref(projectForm).ad_type === AD_TYPE.SEARCH)
  // 是否搜索广告的常规投放
  const isNormal = computed(() => isSearch.value && unref(projectForm).delivery_type === DELIVERY_TYPE.NORMAL)
  // 是否搜索广告的极速智投
  const isDuration = computed(() => isSearch.value && unref(projectForm).delivery_type === DELIVERY_TYPE.DURATION)
  // 是否开启蓝海流量
  const isBlueFlowEnable = computed(() => {
    const { blue_flow_package } = unref(projectForm)
    return isSearch.value && blue_flow_package?.blue_flow_package_setting === BLUE_FLOW_PACKAGE_SETTING_SWITCH.ON
  })

  // 是否是首日roi+7日roi
  const isFirstRoiGoal = computed(() => {
    const { deep_bid_type } = unref(projectForm)?.delivery_setting?.optimize_goal || {}
    return deep_bid_type === DEEP_BID_TYPE.FIRST_AND_SEVEN_PAY_ROI
  })

  // 当项目深度优化方式为ROI系数、每次付费+7日ROI、首日ROI+7日ROI  显示ROI系数
  const adDeepBidVisible = computed(() => {
    const { deep_bid_type } = unref(projectForm)?.delivery_setting?.optimize_goal || {}
    if (!deep_bid_type) return false
    return [DEEP_BID_TYPE.ROI_COEFFICIENT, DEEP_BID_TYPE.FIRST_AND_SEVEN_PAY_ROI, DEEP_BID_TYPE.PER_AND_SEVEN_PAY_ROI].includes(
      deep_bid_type
    )
  })

  // 手动投放且未开启cbo时可以设置广告预算
  const adBudgetVisible = computed(() => {
    const { delivery_mode, delivery_setting } = unref(projectForm)
    if (delivery_setting?.budget_optimize_switch === BUDGET_OPTIMIZE_SWITCH.ON) return false
    if (isAll.value && delivery_mode === DELIVERY_MODE.MANUAL) return true
    return false
  })

  // 手动投放且投放策略不为最大转化时显示
  const adBidVisible = computed(() => {
    const { delivery_mode, delivery_setting } = unref(projectForm)
    if (!delivery_setting) return false
    if (delivery_setting.bid_type === BID_TYPE.NO_BID) return false
    if (isAll.value && delivery_mode === DELIVERY_MODE.MANUAL) return true
    return false
  })

  // 是否显示项目出价和项目深度roi
  const projectBidVisible = computed(() => {
    const { bid_type } = unref(projectForm).delivery_setting || {}
    if (isSearch.value) {
      // 搜索广告：极速智投可设置项目出价
      if (isDuration.value) return true
      // 搜索广告：常规投放稳定成本可设置项目出价
      return isNormal.value && bid_type === BID_TYPE.CUSTOM
    }
    // 通投广告：自动投放且竞价策略等于稳定成本
    return isProcedural.value && bid_type === BID_TYPE.CUSTOM
  })

  return {
    isAll,
    isNormal,
    isDuration,
    isSearch,
    isProcedural,
    isBlueFlowEnable,
    isFirstRoiGoal,
    projectBidVisible,
    adDeepBidVisible,
    adBudgetVisible,
    adBidVisible
  }
}
